import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";

@Component({ name: "LanguageSelector" })
export default class LanguageSelector extends Vue {
    public selectedCountry: string = null;
    public isVisible: boolean = false;
    public countries: any[] = [];
    public languages: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    get isLanguageSelectorVisible() {
        return this.$store.getters["languageSelectorStore/isLanguageSelectorVisible"];
    }

    @Prop() readonly countryCode: string;
    @Prop() readonly routeName: string;
    @Prop() readonly isIndex: boolean;

    @Watch("isLanguageSelectorVisible") async onLanguageSelectorVisibilityUpdate(newValue: boolean) {
        if (newValue) {
            await this.getCountry();
        }

        this.isVisible = newValue;
        this.onCountrySelect(false);
    }

    public async getCountry() {
        const result = (await Axios.post(this.routes.Geo_GetCountries)).data;
        this.countries = result;

        this.selectedCountry = this.countries.find(x => x.code === this.countryCode)?.code;
    }

    public onCountrySelect(reload: boolean) {
        let selectedLanguage = [];
        this.languages = [];
        if (this.selectedCountry) {
            for (const country of this.countries) {
                if (country.code === this.selectedCountry) {
                    selectedLanguage.push(country.languages);
                }
            }

            for (const language of selectedLanguage[0]) {
                this.languages.push(language);
            }

            if (this.languages.length === 1 && reload) {
                this.setCountry(this.languages[0].value);
            }
        }
    };

    public async setCountry(languageCode) {
        if (this.selectedCountry && languageCode) {
            const result = (await Axios.post(this.routes.Geo_SetCountry, { countryCode: this.selectedCountry, languageCode: languageCode, routeName: this.routeName })).data;

            window.location.href = result.url;
        }
    };

    public closeLanguageSelector() {
        this.$store.commit("languageSelectorStore/setLanguageSelectorVisible", false);
        this.selectedCountry = this.countries.find(x => x.code === this.countryCode).code;
    }
};